export default __webpack_public_path__ + "7d2169169f7d1316cec9b5733dd59718.svg";